import type { PageLoad } from './$types';
import * as m from '$lib/paraglide/messages';
import { buildSeoMeta } from '$lib/seo';
import { serializeSchema } from '$lib/jsonld';

export const prerender = true;

export const load: PageLoad = ({ url }) => {
	return {
		seo: buildSeoMeta({
			type: 'home',
			title: m.legal_notices_of_me(),
			url: url.href,
			description: m.legal_page_description()
		}),
		jsonld: serializeSchema({
			'@context': 'https://schema.org',
			'@type': 'WebPage',
			name: m.legal_notices_of_me(),
			description: m.legal_page_description(),
			publisher: {
				'@type': 'Person',
				name: 'Juslin Komenan'
			}
		})
	};
};
